<template>
  <footer class="footer-fr">
    <div class="footer-body-fr">
      <div class="footer-widget-fr footer-identity">
        <img
          alt="Karier.mu"
          class="kariermu-footer-logo-fr"
          src="https://cdn.karier.mu/kariermu/2023/assets/kariermu-logo.svg"
        />
        <div class="copyright-fr inter-medium_small-bold">
          © {{ fullYear }} Karier.mu PT Semesta Integrasi Digital. All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>
<script>

export default {
  name: 'FooterFaceRecognitionResult',
  computed: {
    fullYear () {
      const date = new Date()
      const year = date.getFullYear()
      return year
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@sekolahmu/sekolahmu-design-system-next/src/styles/mixins/_breakpoint.scss';

.footer-fr {
  background-color: var(--color-neutral-300);
  display: flex;
  height: 104px;
  justify-content: space-around;
  align-items: flex-start;
  width: 100%;

  @media (max-width: 1140px) {
    padding: 8px 0;
    height: 124px;
  }

  @media (max-width: 914px) {
    height: 134px;
  }

  @media (max-width: 497px) {
    height: 148px;
  }
}

.footer-body-fr {
  width: 100%;
  max-width: 1140px;
  height: 104px;
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-300);

  .kariermu-footer-logo-fr {
    width: 100%;
    max-width: 90px;
    height: auto;

    @media (max-width: 1140px) {
      margin-bottom: 4px;
    }

    @media (max-width: 497px) {
      margin-bottom: 14px;
    }
  }
}

.footer-widget-fr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-align: center;
  position: relative;

  @media (max-width: 1140px) {
    flex-direction: column;
  }
}

.copyright-fr {
  color: var(--color-text-secondary);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);

  @media (max-width: 1140px) {
    top: 108%;
  }

  @media (max-width: 914px) {
    top: 114%;
  }
}
</style>
